export const AmplitudeEvents = {
	COMMON_GENERATE_CLICK: 'common_generate_click',

	STUDIO_SCREEN_ARRIVE: 'studio_arrive',
	STUDIO_SCREEN_GENERATE_CLICK: 'studio_generate_click',
	STUDIO_TRUE_TOUCH_ENHANCE_CLICK: 'studio_true_touch_enhance_click',
	STUDIO_USE_THIS_CHARACTER_CLICK: 'studio_use_this_prompt_click',
	STUDIO_CREATE_NEW_CHARACTER_CLICK: 'studio_create_new_char_click',
	STUDIO_NARRATOR_GENERATE_CLICK: 'studio_narrator_generate_click',
	STUDIO_CHANGE_CLOTHING_GENERATE_CLICK: 'studio_swap_clothes_click',
	STUDIO_PRODUCT_PHOTO_GENERATE_CLICK: 'studio_generate_product_photo_click',
	STUDIO_UPSCALE_CLICK: 'studio_upscale_click',
	STUDIO_FACE_REPLACE: 'studio_replace_face_click',
	STUDIO_VIDEO_FACESWAP_GENERATE_CLICK: 'studio_vid_faceswap_generate_click',

	CANVAS_CHANGE_CLOTHING_GENERATE_CLICK: 'canvas_swap_clothes_click',
	CANVAS_PRODUCT_PHOTO_GENERATE_CLICK: 'canvas_generate_product_photo_click',
	CANVAS_UPSCALE_CLICK: 'canvas_upscale_click',
	CANVAS_FACE_REPLACE: 'canvas_replace_face_click',
	CANVAS_CREATE_NEW_CHARACTER_CLICK: 'canvas_create_new_char_click',

	PROFILE_SCREEN_ARRIVE: 'profile_screen_arrive',

	SIGNED_OUT_POP_UP_ARRIVE: 'signed_out_pop_up_arrive',
	SIGNED_OUT_CONTW_GOOGLE_CLICK: 'signed_out_pop_up_contw_google_click',

	PRICING_POP_UP_ARRIVE: 'insuff_credits_modal_arrive',
	PRICING_POP_UP_ADD_CREDITS_CLICK: 'insuff_credits_modal_pack_click',

	PRICING_SCREEN_ARRIVE: 'pricing_arrive',
	PRICING_SCREEN_PACK_CLICK: 'pricing_pack_click',
	PAY_SUCCESS_POP_UP_ARRIVE: 'buy_credits_status_success_modal_arrive',
	PAY_ERROR_POP_UP_ARRIVE: 'buy_credits_status_error_modal_arrive',

	CANVAS_SCREEN_ARRIVE: 'canvas_arrive',

	CREATE_ACCOUNT_CLICK: 'signup_create_account_click',
	CREATE_ACCOUNT_WITH_GOOGLE_CLICK: 'signup_contw_google_click',

	LOGIN_CLICK: 'login_login_click',
	LOGIN_WITH_GOOGLE_CLICK: 'login_contw_google_click',
	NSFW_TOAST: 'nsfw_toast_arrive',
	SOMETHING_WENT_WRONG_TOAST: 'sth_went_wrong_toast_arrive',

	MY_CANVASES_SCREEN_ARRIVE: 'my_canvases_arrive',
	MY_CANVASES_SCREEN_CREATE_NEW_CLICK: 'my_canvases_create_new_click',
	CANVAS_SCREEN_GENERATE_CLICK: 'canvas_generate_click',
	CANVAS_TRUE_TOUCH_ENHANCE_CLICK: 'canvas_true_touch_enhance_click',
	CANVAS_VIDEO_FACESWAP_GENERATE_CLICK: 'canvas_vid_faceswap_generate_click',
	CANVAS_USE_THIS_CHARACTER_CLICK: 'canvas_use_this_prompt_click',

	SHARE_CANVAS_SIGNUP_CLICKED: 'share_canvas_signup_clicked',

	STUDIO_SCREEN_CHANGEIT_CLICK: 'studio_changeit_click',
	LOGGED_OUT: 'logged_out',

	NARRATOR_SCRIPT_POPUP_GENERATE_CLICK: 'app_home_narrator_generate_click',
	CANVAS_NARRATOR_GENERATE_CLICK: 'canvas_narrator_generate_click',

	YOUR_CHARACTER_ARRIVE: 'your_characters_arrive',

	APP_HOME_ARRIVE: 'app_home_arrive',
	APP_HOME_TRY_FACESWAP: 'app_home_try_faceswap',
	APP_HOME_TRY_NARRATOR_CLICK: 'app_home_trynow_narrator_click',
	APP_HOME_TRY_POST_CONTROL: 'app_home_trynow_poselock_click',
	APP_HOME_TRY_TRUE_TOUCH: 'app_home_trynow_truetouch_click',
	APP_HOME_TRY_8k_UPSCALE: 'app_home_trynow_upscale_click',
	APP_HOME_UPSCALE_CLICK: 'app_home_upscale_click',
	APP_HOME_TRY_FACE_REPLACE: 'app_home_trynow_facereplace_click',
	APP_HOME_FACE_REPLACE: 'app_home_replace_face_click',
	APP_HOME_POSE_CONTROL_POPUP_GENERATE_CLICK: 'app_home_pose_ctrl_popup_generate_click',
	APP_HOME_TRUE_TOUCH_POPUP_ENHANCE_CLICK: 'app_home_true_touch_popup_enhance_click',
	APP_HOME_TRY_FLUX_CLICK: 'app_home_try_flux_click',
	APP_HOME_TRY_CHANGE_CLOTHING_CLICK: 'app_home_try_now_swap_clothes_click',
	APP_HOME_CHANGE_CLOTHING_GENERATE_CLICK: 'app_home_swap_clothes_click',
	APP_HOME_TRY_PRODUCT_PHOTO_CLICK: 'app_home_try_now_product_photo_click',
	APP_HOME_PRODUCT_PHOTO_GENERATE_CLICK: 'app_home_generate_product_photo_click',
	APP_HOME_TRY_MUSIC_VIDEO_CLICK: 'app_home_try_now_music_video_click',

	VIDEO_ANYONE_SUBSCRIBE_MODAL_CLICK: 'vid_anyone_subscribe_modal_click',

	HISTORY_ARRIVE: 'history_arrive',
	QUICK_START_IMAGE_GENERATE_CLICK: 'quick_start_img_generate_click',
	QUICK_START_NARRATOR_GENERATE_CLICK: 'quick_start_narrator_generate_click',

	STUDIO_VIDEO_ANYONE_GENERATE_CLICK: 'studio_vid_anyone_generate_click',
	CANVAS_VIDEO_ANYONE_GENERATE_CLICK: 'canvas_vid_anyone_generate_click',

	DOWNLOAD_MAC_OS_APP: 'download_mac_os_app',

	STUDIO_MUSIC_VIDEO_GENERATE_SCENES_CLICK: 'studio_music_vid_gen_scenes_click',
	CANVAS_MUSIC_VIDEO_GENERATE_SCENES_CLICK: 'canvas_music_vid_gen_scenes_click',

	STUDIO_MUSIC_VIDEO_GENERATE_CLICK: 'studio_music_vid_gen_video_click',
	CANVAS_MUSIC_VIDEO_GENERATE_CLICK: 'canvas_music_vid_gen_video_click',

	STUDIO_MUSIC_VIDEO_MODIFY_SCENE_CLICK: 'studio_music_vid_modify_scene_click',
	CANVAS_MUSIC_VIDEO_MODIFY_SCENE_CLICK: 'canvas_music_vid_modify_scene_click',

	STUDIO_MUSIC_VIDEO_FEED_RESUME_CLICK: 'studio_music_vid_feed_resume_click',
	CANVAS_MUSIC_VIDEO_FEED_RESUME_CLICK: 'canvas_music_vid_feed_resume_click',

	APP_HOME_TUTORIAL_VIDEO: 'app_home_tutorial_vid_',
	APP_HOME_GENERATE_VIDEO_CLICK: 'app_home_generate_video_click',
	APP_HOME_GENERATE_IMAGE_CLICK: 'app_home_generate_image_click',
	APP_HOME_USE_THIS_PROMPT_CLICK: 'app_home_use_this_prompt_click',
	APP_HOME_CREATE_NEW_CHARACTER_CLICK: 'app_home_create_new_char_click',
	APP_HOME_MUSIC_VIDEO_MODAL_GENERATE_SCENES_CLICK: 'app_home_music_vid_gen_scenes_click',
	APP_HOME_PRODUCT_PHOTO_BANNER_CLICK: 'app_home_product_photo_banner_click',

	// CHARACTER
	YOUR_CHARACTER_CREATE_NEW_CHARACTER_CLICK: 'your_characters_create_new_char_click',
	GENERATE_NEW_CHARACTER_FLOW: 'create_new_char_popup_generate_new_click',
	UPLOAD_NEW_CHARACTER_FLOW: 'create_new_char_popup_use_face_click',
	GENERATE_NEW_CHARACTER_BUTTON_CLICK: 'create_new_char_popup_generate_char_click',
	CREATE_NEW_CHARACTER_SAVE_BUTTON_CLICK: 'create_new_char_popup_save_char_click',
	YOUR_CHARACTER_GENERATE_CHARACTER_CLICK: 'your_character_generate_char_click',
	USE_THIS_CHARACTER_CLICK: 'use_this_char_click',
	YOUR_CHARACTER_DETAILS_GENERATE_CLICK: 'your_characters_char_details_generate_click',

	ACCOUNT_DETAILS_ARRIVE: 'account_details_arrive',
	ACCOUNT_DETAILS_JOIN_DISCORD_CLICK: 'account_details_join_discord_click',

	// Electron Events
	GENERATE_ELECTRON_APP: 'generate_electron_app',
	ELECTRON_LOGIN_PAGE_ARRIVE: 'electron_login_page_arrive',
	ELECTRON_CANVAS_LIST_PAGE_ARRIVE: 'electron_canvas_list_page_arrive',
};
